import keys from 'lodash/keys'
import { palette } from '@omnea-app/omui/private/palette'

type Input = {
  possibleScores: number[]
  score?: number
  type: 'light' | 'dark'
}

type Output = {
  color: string
  borderColor: string
  backgroundColor: string
}

/* This function divides the possible scores into 5 equal buckets based on range. Then it places the score provided
 * into its bucket. The idea is to map a score to the colour where it should fit. You can check the unit tests
 * for examples of how it works and edge cases */
export const getRiskScoreColorSx = ({ possibleScores, score = 0, type }: Input): Output => {
  if (score === 0 || possibleScores.length === 0)
    return {
      color: palette.riskScore[type].color[0],
      borderColor: palette.riskScore[type].border[0],
      backgroundColor: palette.riskScore[type].background[0],
    }
  const sortedScoresWithoutZero = possibleScores.sort((a, b) => a - b).filter((score) => score !== 0)
  const totalScores = sortedScoresWithoutZero.length
  const numberOfColors = keys(palette.riskScore[type].color).filter((key) => key !== '0').length
  const numberOfBuckets = Math.min(numberOfColors, totalScores)
  const minScore = sortedScoresWithoutZero[0] as number
  const maxScore = sortedScoresWithoutZero[totalScores - 1] as number
  const normalizedScore = sortedScoresWithoutZero.length === 1 ? 1 : (score - minScore) / (maxScore - minScore)
  const bucketIndex = Math.ceil(normalizedScore * (numberOfBuckets - 1) + 1) as 1 | 2 | 3 | 4 | 5

  return {
    color: palette.riskScore[type].color[bucketIndex],
    borderColor: palette.riskScore[type].border[bucketIndex],
    backgroundColor: palette.riskScore[type].background[bucketIndex],
  }
}
